// Some errors have multiple error codes because JDPI can return their own internal errors and also BCB errors so we need to be able to handle both

const error = {
  dict: {
    entryLockedByClaim: 'EntryLockedByClaim',
    entryLimitExceeded: 'EntryLimitExceeded',
    entryKeyOwnedByDifferentPerson: ['EntryKeyOwnedByDifferentPerson', 'JDPICHV005'],
    entryKeyInCustodyOfDifferentParticipant: ['EntryKeyInCustodyOfDifferentParticipant', 'JDPICHV010'],
    entryAlreadyExists: ['EntryAlreadyExists', 'JDPICHV004'],
    claim: {
      claimAlreadyExistsForKey: ['ClaimAlreadyExistsForKey', 'JDPIRVN014']
    }
  },
  is(error, target) {
    if (Array.isArray(target)) {
      return target.includes(error);
    }
    return error === target;
  }
};

module.exports = error;
